module.exports = __webpack_public_path__ + "img/CoGCa.088b55cd.png";